function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { formatDateTime } from "./format.js";

/**
 * Get localized date (without date)
 * @example localizeDateTime(2020-10-15T19:51:45.291Z) => 10/15/2020
 * @param dateTime Date | string
 * @param locale string | string[]
 * @param options Intl.DateTimeFormatOptions | undefined
 * @returns string
 */
var localizeDate = function localizeDate(dateTime, locale, options) {
  var locales = [navigator.language];
  if (locale) {
    if (Array.isArray(locale)) {
      var _iterator = _createForOfIteratorHelper(locale),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var l = _step.value;
          locales.unshift(l);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      locales.unshift(locale);
    }
  }
  return formatDateTime(dateTime, locales, options || {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
  });
};
export { localizeDate };